import { memo } from 'react';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';

import { findPathPages } from 'utils/pages';

import Typography from 'components/UI/Typography/Typography';

import { getIcon } from 'components/config/cloud';
import { PAGE_PATH } from 'components/config/pages';

import { ReactComponent as TopBannerStroke } from 'images/Analytics/TopBannerStroke.svg';

import styles from './TopGameCard.module.scss';

const TopGameCard = ({ gameCode, title, strokeColor, inlineIcon }) => (
  <Link
    to={findPathPages(PAGE_PATH.GAME).replace(':gameCode', gameCode)}
    className={styles.root}
  >
    <div className={styles.iconWrapper} style={{ color: strokeColor }}>
      <img
        src={getIcon(gameCode)}
        alt="game_icon"
        className={styles.gameIcon}
      />
      <TopBannerStroke className={styles.stroke} />
      <div
        dangerouslySetInnerHTML={{ __html: inlineIcon }}
        className={styles.icon}
      />
    </div>
    {title && (
      <Typography weight="semibold" style={{ color: strokeColor }}>
        {title}
      </Typography>
    )}
  </Link>
);

TopGameCard.propTypes = {
  gameCode: PropTypes.string.isRequired,
  title: PropTypes.string,
  strokeColor: PropTypes.string.isRequired,
  inlineIcon: PropTypes.string.isRequired,
};

export default memo(TopGameCard);
